import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AutoColumn } from '../../components/Column'
import { RowBetween } from '../../components/Row'
import { Text } from 'rebass'
import { ThemeContext } from 'styled-components'
import { HoverCard } from '../../components/PositionCard/all'
import Slider from '../../components/Slider'
import { MaxButton } from './styleds'
import { ButtonSecondary } from '../../components/Button'
import {
  usePerLiquidityRewardYearPercent,
  useSettleAllRewards,
  useUpdateLiquidityRewardPercent
} from '../../state/wallet/hooks'

export default function PoolSetting() {
  const { t } = useTranslation()
  const theme = useContext(ThemeContext)
  const [yearlyReward, setYearlyReward] = useState(0)

  const { percent, isLoading } = usePerLiquidityRewardYearPercent()
  const { updatePercent, isUpdating } = useUpdateLiquidityRewardPercent()

  const { settleAllRewards, isSettling } = useSettleAllRewards()

  useEffect(() => {
    percent && setYearlyReward(percent)
  }, [percent])

  return (
    <>
      <AutoColumn gap="12px" style={{ width: '100%' }}>
        <RowBetween padding={'0 8px'}>
          <Text color={theme.text1} fontWeight={500}>
            {t('liquidityYearlyReward')}
          </Text>
        </RowBetween>

        <HoverCard>
          <>
            <Text fontSize={72} fontWeight={500}>
              {isLoading ? t('loading') : `${yearlyReward}%`}
            </Text>
            <Slider value={yearlyReward} onChange={setYearlyReward} />
            <RowBetween>
              <MaxButton disabled={isLoading} onClick={() => setYearlyReward(20)} width="20%">
                20%
              </MaxButton>
              <MaxButton disabled={isLoading} onClick={() => setYearlyReward(40)} width="20%">
                40%
              </MaxButton>
              <MaxButton disabled={isLoading} onClick={() => setYearlyReward(60)} width="20%">
                60%
              </MaxButton>
              <MaxButton disabled={isLoading} onClick={() => setYearlyReward(80)} width="20%">
                80%
              </MaxButton>
              <MaxButton
                disabled={isLoading}
                style={{ whiteSpace: 'nowrap', paddingLeft: 12 }}
                onClick={() => setYearlyReward(100)}
                width="20%"
              >
                {t('max')}
              </MaxButton>
            </RowBetween>
            <RowBetween marginTop="10px">
              <ButtonSecondary disabled={isLoading || isSettling} width="48%" onClick={() => settleAllRewards()}>
                {t('settle')}
              </ButtonSecondary>
              <ButtonSecondary
                disabled={isLoading || isUpdating}
                width="48%"
                onClick={() => updatePercent(yearlyReward)}
              >
                {t('updateYearly')}
              </ButtonSecondary>
            </RowBetween>
          </>
        </HoverCard>
      </AutoColumn>
    </>
  )
}
